import {takeEvery, put, call, all, fork} from 'redux-saga/effects';

// save to state to track global state

import {GET_FILTERS_DATA, SET_FILTERS_DATA} from './actionTypes';

import {
    getFiltersData,
    getFiltersDataSuccess,
    getFiltersDataFail,
    setFiltersData,
    setFiltersDataSuccess,
    setFiltersDataFail
} from './actions';

// save to state to track global state
// get initial state from reducer

function* fetchFiltersData(){
    // get data from INIT_STATE
    yield put(getFiltersDataSuccess(getFiltersData()));
}

export function* watchFetchFiltersData() {
    yield takeEvery(GET_FILTERS_DATA, fetchFiltersData);
}

// set filters data to state
export function* setFiltersDataSaga({payload}) {
    try {
        yield put(setFiltersDataSuccess(payload));
    } catch (error) {
        yield put(setFiltersDataFail(error));
    }
}

export function* watchSetFiltersData() {
    yield takeEvery(SET_FILTERS_DATA, setFiltersDataSaga);
}

function* filtersSaga() {
    yield all([
        fork(watchFetchFiltersData),
        fork(watchSetFiltersData)
    ]);
}
export default filtersSaga;